export const MOBILEVIEWLABEL = {
    english: { step: 'Step', of: 'Of' },
    spanish: { step: 'Paso', of: 'de' },
    hindi: { step: 'चरण', of: 'का' }
};